import _find from 'lodash/find';

type BankCaptureState = {
  file?: {
    fields2?: {
      bankStatement?: Record<string, string | null | undefined>;
    } | null;
  } | null;
  ocrFields?: Array<{ key?: string; value?: string }> | null;
};

// Normalise an OCR-returned BSB to the required XXX-XXX format.
// Handles variants produced by OCR: "633 000", "633000", "633-000".
export const normalizeBSB = (raw: string): string => {
  const digits = raw.replace(/\D+/g, '');
  if (digits.length === 6) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  return raw;
};

// The seller keeps the details they already submitted; ocrFields only survives
// the session that captured the image.
const fieldValue = (bank: BankCaptureState | null | undefined, key: string) =>
  bank?.file?.fields2?.bankStatement?.[key] ||
  _find(bank?.ocrFields, { key })?.value ||
  '';

export const getBankReviewDefaults = (
  bank: BankCaptureState | null | undefined
) => ({
  accountNumber: fieldValue(bank, 'accountNumber'),
  bsbValue: normalizeBSB(fieldValue(bank, 'bsb')),
  addressLine1: fieldValue(bank, 'addressLine1'),
  addressLine2: fieldValue(bank, 'addressLine2'),
  bankName: fieldValue(bank, 'bankName'),
  accountName: fieldValue(bank, 'accountName')
});
